<template>
  <!-- David comment -->
  <!-- This my change -->
  <div>
    <Slider />
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <div class="row clearfix">
            <div class="col-lg-5">
              <div class="heading-block topmargin">
                <h1>
                  Welcome to<br />
                  INFINITY DANCE STUDIO.
                </h1>
              </div>
              <p class="lead">
                Infinity Dance Studio began as a dream. A dream guided by a vision to transmit teachings, lessons, and an immense love for dancing. We
                are an institution specialized in children and young adults with the objective of becoming professionals in any of the dance
                disciplines, for those who consider dance an essential complement of their formal education, and for those who simply love this form
                of art.
              </p>
            </div>
            <div class="col-lg-7">
              <div
                data-height-xxs="380"
                data-height-xs="287"
                data-height-sm="470"
                data-height-md="567"
                data-height-lg="626"
                class="ohidden"
                style="position: relative; margin-bottom: -60px;"
              >
                <img
                  alt="Chrome"
                  data-delay="100"
                  data-animate="fadeInUp"
                  style="position: absolute; top: 0px; left: 0px;"
                  src="/assets/img/InfinityDanceStudio.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix topmargin-lg"></div>
        <div class="container clearfix topmargin-lg bottommargin-lg">
          <div class="col_one_third bottommargin">
            <div class="feature-box media-box">
              <div class="fbox-media">
                <router-link :to="{ name: 'Competition' }">
                  <img src="/assets/img/test1.jpg" alt="Competition Dance" />
                </router-link>
              </div>
              <div class="fbox-desc">
                <h3>
                  <router-link :to="{ name: 'Competition' }"> Competition dance</router-link
                  ><span class="subtitle">For dancers ages 5 through 18</span>
                </h3>
                <p>
                  Team members are selected through an annual audition process. Our studio's goal is to provide as many dancers as possible the
                  opportunity to continuously challenge themselves in an different environment while providing the same superior dance education we
                  are known to offer to all of our students.
                </p>
              </div>
            </div>
          </div>
          <div class="col_one_third nobottommargin">
            <div class="feature-box media-box">
              <div class="fbox-media">
                <router-link :to="{ name: 'Classes' }">
                  <img src="/assets/img/recreational-dance.jpg" alt="Recreational Dance" />
                </router-link>
              </div>
              <div class="fbox-desc">
                <h3>
                  <router-link :to="{ name: 'Classes' }">
                    recreational dance
                  </router-link>
                  <span class="subtitle">Studio Dance, Fitness, and Recreational Classes.</span>
                </h3>
                <p>
                  We are pleased to have certified and professional dance staff members trained in specific genres of dance with rich background in
                  performance, training and choreography.
                </p>
              </div>
            </div>
          </div>
          <div class="col_one_third nobottommargin col_last">
            <div class="feature-box media-box">
              <div class="fbox-media">
                <router-link :to="{ name: 'Classes' }">
                  <img src="/assets/img/seasonal-camp.jpg" alt="Seasonal Camps" />
                </router-link>
              </div>
              <div class="fbox-desc">
                <h3>
                  <a href="/camps">seasonal camps &amp; programs</a><span class="subtitle">Summer, Afterschool &amp; Daytime Camps Available</span>
                </h3>
                <p>
                  Our purpose is to provide a summer program for our dancers to can develop their passion for dancing and improve their technique in
                  all disciplines in a secure and fun environment.
                </p>
              </div>
            </div>
          </div>
        </div>
        <a class="button button-full button-dark center tright " href="contact.html">
          <div class="container clearfix">
            Ready join our Dance Team? <strong>Call us</strong> <em style="top: 4px;" class="icon-caret-right"></em>
          </div>
        </a>
        <div class="nobottommargin nobottomborder">
          <div class="container clearfix">
            <div class="heading-block center topmargin-lg">
              <h3>Our Latest Works</h3>
            </div>
          </div>
        </div>
        <div class="portfolio-nomargin portfolio-notitle portfolio-full clearfix" id="portfolio">
          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/1t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/1t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>
          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/2t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/2t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>
          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/3t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/3t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>
          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/4t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/4t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>
          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/5t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/5t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>

          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/6t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/6t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>
          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/7t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/7t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>
          <article class="portfolio-item pf-media pf-icons">
            <div class="portfolio-image">
              <a href="portfolio-single.html">
                <img alt="Snow white 2016" src="/assets/img/2016-snow-white/8t.jpg" />
              </a>
              <div class="portfolio-overlay">
                <a data-lightbox="image" class="center-icon" href="/assets/img/2016-snow-white/8t_large.jpg"><em class="icon-line-plus"></em></a>
              </div>
            </div>
            <div class="portfolio-desc">
              <h3>Snow White</h3>
              <span>2016</span>
            </div>
          </article>
        </div>
        <!-- <div class="nobottommargin nobottomborder">
                    <div class="container clearfix">
                        <div class="heading-block center topmargin-lg">
                            <h3>INSTAGRAM FEED</h3>
                        </div>
                    </div>
                </div> -->
        <!--<script type="text/javascript">
                    jQuery(window).load(function() {

                        var $container = $('#portfolio');

                        $container.isotope({
                            transitionDuration: '0.65s',
                            masonry: {
                                columnWidth: $container.find('.portfolio-item:not(.wide)')[0]
                            }
                        });

                        $('#page-menu a').click(function() {
                            $('#page-menu li').removeClass('current');
                            $(this).parent('li').addClass('current');
                            var selector = $(this).attr('data-filter');
                            $container.isotope({
                                filter: selector
                            });
                            return false;
                        });

                        $(window).resize(function() {
                            $container.isotope('layout');
                        });

                    });
                </script>-->
        <!-- <div>
                    <div class="container clearfix">
                        <div class="row">
                            <div class="heading-block center topmargin-lg">
                                <h3>Meet Our Team</h3>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="John Doe" src="@/assets/img/Paty.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Patricia Barreiro</h4>
                                            <span>Director and Instructor </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Irasema Berreiro" src="/assets/img/iracema.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Irasema Cabrera</h4>
                                            <span>Co-Founder </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="/assets/img/Paula.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Paula Barreiro</h4>
                                            <span>Assistant</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Nuris" src="@/assets/img/destiny.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Destiny Diaz</h4>
                                            <span>Hip Hop and Contemporary Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Irasema Berreiro" src="@/assets/img/Nuris.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Niuris Torres</h4>
                                            <span>Assistant Director and Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/teacher.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Alihaydee Carreño</h4>
                                            <span>Ballet Maitre</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Nuris" src="@/assets/img/kelly.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Kelly Rodriguez</h4>
                                            <span>Belly Dance Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Irasema Berreiro" src="@/assets/img/abuela.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Angela Cabrera</h4>
                                            <span> </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/yadida.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Yadira Garcia</h4>
                                            <span>Acrobatics Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->
      </div>
    </section>

    <!-- <iframe src="https://api.instagram.com/oembed?url=https://www.instagram.com/infinitydancestudio/" frameborder="0"></iframe> -->

    <!-- <iframe src="http://lightwidget.com/widgets/fef6ea691aa555e7874b9915019cb3b6.html" id="lightwidget_fef6ea691a" name="lightwidget_fef6ea691a" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width: 100%; border: 0; overflow: hidden;"></iframe> -->
  </div>
</template>

<script>
import Slider from '@/components/home/partials/Slider.vue'

export default {
  name: 'Home',
  components: {
    Slider,
  },

  mounted() {
    jQuery(window).load(function() {
      // var $container = jQuery('#portfolio');

      // $container.isotope({
      //     transitionDuration: '0.65s',
      //     masonry: {
      //         columnWidth: $container.find('.portfolio-item:not(.wide)')[0]
      //     }
      // });

      jQuery('#page-menu a').click(function() {
        jQuery('#page-menu li').removeClass('current')
        jQuery(this)
          .parent('li')
          .addClass('current')
        var selector = $(this).attr('data-filter')
        $container.isotope({
          filter: selector,
        })
        return false
      })

      // jQuery(window).resize(function() {
      //     $container.isotope('layout');
      // });
    })
  },
}
</script>
